import React, { useState, useEffect } from "react";
import CartLocationHistoryModal from "./../modals/CartLocationHistoryModal/CartLocationHistoryModal";
import { Grid } from "semantic-ui-react";
import { SignalR } from "./../../utils/SignalRUtil";
import "./InfoFooter.css";
import { Icon } from 'semantic-ui-react'

const InfoFooter = ({
  sortID,
  cartID,
  cartShelf,
  workstationID,
  operatorName,
  isApoteaPackaging,
  companyID,
  pendingInstruction,
  boxID,
  orderNumber,
  cartLocationHistory,
  singleTransportCart = "",
  normalTransportCart = "",
  rxSignalRConnectionStatus = false,
  rxAuto = false,
  hasHelpPicklist = false
}) => {
  const [SRState, setSRState] = useState(-1);
  const [cartLocationHistoryModalOpen, setCartLocationHistoryModalOpen] = useState(false);

  const cartLinkOnClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCartLocationHistoryModalOpen(!cartLocationHistoryModalOpen);
  };

  const cartLocationHistoryModalOnClose = () => {
    setCartLocationHistoryModalOpen(false);
  };

  const cartLinkText = cartID ?? '' + (hasHelpPicklist ? " (Hjälpplockad)" : "");
  const cartLink =
    cartID !== -1 && cartID !== 6999 && cartID !== 5777 ? (
      <a
        onClick={cartLinkOnClick}
        href="/"
        style={{
          color: "black",
        }}
      >
        {cartLinkText}
      </a>
    ) : (
      cartLinkText
    );
  let list = void 0;
  if (!rxAuto) {
      list = [
      ["Lista", sortID],
      ["Box", boxID],
      ["Vagn", cartLink],
      ["Fack", cartShelf],
      ["Stationsnummer", workstationID],
      ["Operatör", operatorName],
      ["Nästa Instruktion", pendingInstruction],
      ["Order", orderNumber],
    ].filter((x) => !!x[1]);
    if (singleTransportCart !== ""){
      list.push(["Singelback", singleTransportCart]);
    }
    if (normalTransportCart !== ""){
      list.push(["Normalback", normalTransportCart]);
    }
  } else {
    list = [
      ["Stationsnummer", workstationID],
      ["Operatör", operatorName],
      ["Order", orderNumber]
    ]
  }

  const columns = list.map((c) => {
    let width =
      c[0] === "Lista" || c[0] === "Vagn" || c[0] === "Fack"
        ? 1
        : c[0] === "Nästa Instruktion"
        ? 4
        : 2;
    if (list.length < 6) width = 2;
    return (
      <Grid.Column key={c[0]} width={width} style={{ whiteSpace: "nowrap" }}>
        <b>{c[0] + ": "}</b>
        {c[1]}
      </Grid.Column>
    );
  });

  const getClassFromSRState = (s) => {
    switch (s) {
      case 0:
        return "Connecting";
      case 1:
        return "Connected";
      case 2:
        return "Reconnecting";
      case 4:
        return "Disconnected";
      default:
        return "";
    }
  };

  const getRxSignalRConnectionStatusClass = (state) => {
    return state ? "Connected" : "Disconnected";
  }

  useEffect(() => {
    const id = setInterval(() => {
      setSRState(SignalR.getState());
    }, 500);
    return () => clearInterval(id);
  });

  return (
    <div
      className={
        "InfoFooter" + (isApoteaPackaging ? " color-1" : companyID > 0 ? ` color-${companyID}` : "")
      }
    >
      <Grid>
        <Grid.Row centered>{columns}</Grid.Row>
      </Grid>
      <div className={"SignalRStatus " + getClassFromSRState(SRState)}></div>
      { rxAuto && (
        <div className="RXSignalRStatus">
          <Icon size="large" className={getRxSignalRConnectionStatusClass(rxSignalRConnectionStatus)} name="signal"></Icon>
        </div>
      ) 
      }
      <CartLocationHistoryModal
        open={cartLocationHistoryModalOpen}
        cartLocationHistory={cartLocationHistory}
        onClose={cartLocationHistoryModalOnClose}
      />
    </div>
  );
};

export default InfoFooter;
